// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kp-0";